import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';
import s from './ui.module.scss';

/**
 * Le bouton de la borne.
 *
 * Trois tons, et ils veulent dire quelque chose : `action` engage de l'argent
 * ou lance la partie, `accent` navigue, `ghost` annule ou quitte. Ce sont des
 * roles, pas des couleurs — un ecran qui veut « le bouton rose » se trompe de
 * question.
 */
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: 'action' | 'accent' | 'ghost';
  size?: 'md' | 'lg';
  full?: boolean;
  children: ReactNode;
}

export function Button({
  tone = 'accent',
  size = 'md',
  full = false,
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      // Un bouton sans type explicite vaut `submit` dans un formulaire, ce qui
      // envoie une reponse a chaque clic sur n'importe quel bouton voisin.
      type="button"
      className={cx(s.button, s[`tone-${tone}`], s[`size-${size}`], full && s.full, className)}
      {...rest}
    >
      {children}
    </button>
  );
}
